import type { Prompt } from "@1js/pl-card-components";
import DOMPurify from "dompurify";

export const usePromptActions = () => {
  const handleCopyClicked = (
    prompt: Prompt,
    onSuccess: (prompt: Prompt) => void
  ) => {
    let copiedCommand = prompt.CommandText;
    if (!prompt.Products?.includes("BizChat")) {
      copiedCommand = DOMPurify.sanitize(prompt.CommandText, {
        IN_PLACE: true,
        ALLOWED_TAGS: ["placeholder"],
      });
    }

    copiedCommand = replacePlaceholderTag(copiedCommand);

    navigator.clipboard.writeText(copiedCommand);
    onSuccess(prompt);
  };

  return {
    handleCopyClicked,
  };
};

const replacePlaceholderTag = (commandText: string) => {
  return commandText
    .replace("<placeholder>", "[")
    .replace("</placeholder>", "]");
};
